// import * as icons from "@material-ui/icons";
import { AppBar, IconButton, Menu, MenuItem, Toolbar, Typography } from '@material-ui/core';
import * as icons from '@material-ui/icons';
import _get from 'lodash/get';
import * as React from 'react';
import { Link } from 'react-router-dom';

interface IProps {
  fullName: string;
  isDrawerOpened: boolean;
  classes?: {
    root?: string;
    menuIcon?: string;
    title?: string;
  };
  onClickMenu(): void;
  logout(): void;
}

class TopBar extends React.Component<IProps, any> {
  public state = {
    menuAnchorElement: undefined,
  };

  public handleRightMenuOpening() {
    return (event: React.MouseEvent<HTMLAnchorElement>) => {
      this.setState({ menuAnchorElement: event.currentTarget });
    };
  }

  public handleRightMenuClosing() {
    return () => {
      this.setState({ menuAnchorElement: undefined });
    };
  }

  public logout() {
    return () => {
      this.setState({ menuAnchorElement: undefined });
      this.props.logout();
    };
  }

  public render() {
    return (
      <AppBar position="absolute" className={_get(this.props, 'classes.root')}>
        <Toolbar disableGutters={!this.props.isDrawerOpened}>
          <IconButton
            color="inherit"
            aria-label="Open Drawer"
            onClick={this.props.onClickMenu}
            className={_get(this.props, 'classes.menuIcon')}
          >
            <icons.Menu />
          </IconButton>
          <Typography
            className={_get(this.props, 'classes.title')}
            variant="title"
            color="inherit"
            noWrap={true}
          >
            QuickJOBS Admin
          </Typography>
          <div>
            <IconButton onClick={this.handleRightMenuOpening()} color="inherit">
              <icons.AccountCircle />
            </IconButton>
            <Menu
              anchorEl={this.state.menuAnchorElement}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(this.state.menuAnchorElement)}
              onClose={this.handleRightMenuClosing()}
            >
              <MenuItem
                onClick={this.handleRightMenuClosing()}
                component={Link}
                {...{ to: '/account' } as any}
              >
                My Account ({this.props.fullName})
              </MenuItem>
              <MenuItem onClick={this.logout()}>Logout</MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
    );
  }
}

export default TopBar;



// WEBPACK FOOTER //
// ./src/components/TopBar/TopBar.tsx